/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
function updateHeight() {
  // Use vanilla JavaScript to get the height
  var hell = document.querySelector("div#overlay-text").offsetHeight;

  // Set the CSS variable on the root element
  document.documentElement.style.setProperty(
    "--overlay-text-height",
    -hell + "px"
  );
}

// Add event listener for window resize
window.addEventListener("resize", updateHeight);
console.log(updateHeight);
// Call updateHeight initially to set the value on page load
document.addEventListener("DOMContentLoaded", (event) => {
  updateHeight();
});

$(document).ready(function () {
  $(".collection-top-bar-wrapper").each(function () {
    // For each collection top bar wrapper, add click event
    $(this).click(function () {
      // Toggle the 'two-columns' class only on the grid of the specific collection
      $(this)
        .closest(".shopify-section")
        .find("#CollectionLoop")
        .toggleClass("two-columns");
      // Toggle the 'two-column-icon' on the clicked wrapper
      $(this).toggleClass("two-column-icon");
    });
  });
});

document.addEventListener("scroll", function () {
  const videoBanner = document.querySelector(".video-banner");
  const headerSections = document.querySelector(".header-sections");

  if (!videoBanner || !headerSections) return;

  const videoBannerRect = videoBanner.getBoundingClientRect();
  const isVideoBannerInView =
    videoBannerRect.top < window.innerHeight && videoBannerRect.bottom > 0;

  if (isVideoBannerInView) {
    headerSections.classList.add("video-active");
  } else {
    headerSections.classList.remove("video-active");
  }
});